import React, {useRef} from "react"
import ComponentWrapper from "../components/wrapper"
import { Link } from "gatsby"
import ScrollAnimation from '../helpers/scrollAnimations'
import ToolTip from "./tooltip"



const CopyImage = ({reverseZindex, pinline, copy, image, imageAlign, imageSize, ctaButton, hasTooltip=false, tooltip, storyColor }) => {
    const parentCopyEl = useRef(null);

    return (
        <ComponentWrapper>
            <section>
                <ScrollAnimation zIndex={reverseZindex}>
                    <div className={`copy-image ${imageSize ? imageSize : 'medium'} ${imageAlign === "align_left" ? 'copy-image--left' : 'copy-image--right'} ${pinline ? 'pinline' : ''}`}>
                        <div className={`image ${imageSize ? imageSize : 'medium'}`}>
                            { image.localFile.publicURL && 
                                <img src={image.localFile.publicURL} alt={image.alText ? image.altText : ''} />
                            }
                        </div>
                        <div className="text">
                            {pinline && <hr />}
                            <div className="copy" ref={parentCopyEl} dangerouslySetInnerHTML={{__html: copy}} />
                            {hasTooltip &&
                                <ToolTip
                                    storyColor={storyColor}
                                    tooltip={tooltip}
                                    parentCopy={parentCopyEl}
                                />
                            }
                            { ctaButton && 
                                <Link to={ctaButton.url} className={`button button--${storyColor}`} target={ctaButton.target}>{ctaButton.title}</Link>
                            }
                        </div>
                    </div>
                </ScrollAnimation>
            </section>
        </ComponentWrapper>
    )
}

export default CopyImage